import _ from 'lodash';
import { lsErrorService, lsStorageService } from 'ls-vue-common';
import createGraphQLClient from './apolloClient';
import gql from 'graphql-tag';
import {
  AUTH__JWT,
  AUTH__JWT_FETCH,
  LTRS__GET_SCHEDULE_EVENTS,
  LTRS__GROUPED_BY_SCHEDULE,
  LTRS__MUTATE_LOADING_STATUS,
  LTRS__MUTATE_SCHEDULE_EVENTS,
  LTRS__SCHEDULE_EVENTS_RECEIVED,
  LTRS__UNAUTHENTICATED_ERROR_RECEIVED,
} from '@/store/types';

export const LTRS_STATUS_AWAITING_SCHEDULE = 'AWAITING_SCHEDULE';
export const LTRS_STATUS_AWAITING_SERVICE_WINDOW = 'AWAITING_SERVICE_WINDOW';
export const LTRS_STATUS_NEW_PROPERTY = 'NEW_PROPERTY';
export const LTRS_STATUS_SCHEDULED = 'SCHEDULED';

const eventsByCustomerQuery = gql`
  query {
    ScheduleEventsByAPICustomerId {
      data {
        schedule {
          lsApiScheduleId
          property {
            lsApiPropertyId
          }
        }
        windowStart
        windowEnd
        status
        startedAt
        notes
        productsUsed
        technician {
          id
          name
        }
        lsApiScheduleEventId
      }
    }
  }
`;

export const mutations = {
  [LTRS__MUTATE_LOADING_STATUS](state, payload) {
    state.loadingStatus = payload;
  },

  [LTRS__MUTATE_SCHEDULE_EVENTS](state, { data }) {
    state.ltrsEvents = data;
  },
};

export const actions = {
  [LTRS__GET_SCHEDULE_EVENTS](
    { commit, state, dispatch, graphQLClient },
    { forceRefresh = false } = {}
  ) {
    if (!_.isEmpty(state.ltrsEvents) && !forceRefresh) {
      return Promise.resolve();
    }

    commit(LTRS__MUTATE_LOADING_STATUS, { isLoading: true });

    const jwt = lsStorageService.get(AUTH__JWT);

    const { apolloClient } = graphQLClient || createGraphQLClient(jwt);
    return apolloClient
      .query({
        query: eventsByCustomerQuery,
        fetchPolicy: 'no-cache',
      })
      .then(({ data }) => {
        dispatch(LTRS__SCHEDULE_EVENTS_RECEIVED, data.ScheduleEventsByAPICustomerId);
      })
      .catch((error) => {
        const message = _.get(error, 'graphQLErrors[0].message') || '';
        if (/unauthenticated/i.test(message)) {
          dispatch(LTRS__UNAUTHENTICATED_ERROR_RECEIVED);
          return;
        }
        lsErrorService.log({ error, showAlert: true });
      })
      .finally(() => {
        commit(LTRS__MUTATE_LOADING_STATUS, {
          isLoading: false,
        });
      });
  },

  [LTRS__SCHEDULE_EVENTS_RECEIVED]({ commit }, ltrsEvents) {
    commit(LTRS__MUTATE_SCHEDULE_EVENTS, ltrsEvents);
  },

  [LTRS__UNAUTHENTICATED_ERROR_RECEIVED]({ dispatch }) {
    dispatch(AUTH__JWT_FETCH);
    dispatch(LTRS__GET_SCHEDULE_EVENTS);
  },
};

export const getters = {
  [LTRS__GROUPED_BY_SCHEDULE](state) {
    return _.groupBy(state.ltrsEvents, 'schedule.lsApiScheduleId');
  },
};

export const ltrs = {
  state: { ltrsEvents: [], isLoading: false },
  mutations,
  actions,
  getters,
};
